export default __webpack_public_path__ + "static/media/Pudim-Flan.cf4e1922.jpg";